<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :fill="fill"
       viewBox="0 0 1280 121.69">
    <path d="m1280,121.69H0l53.33-31.9C106.67,57.88,213.33-5.93,320,.45s213.33,82.95,320,82.95S853.33,6.83,960,.45c106.67-6.38,213.33,57.43,266.67,89.34l53.33,31.9Z"/>
  </svg>
</template>

<script>
export default {
  name: "WaveIcon",
  props: {
    fill: {
      type: String,
      default: '#fff'
    },
  }
}
</script>
